import { LOADING, SET_MESSAGE } from "../../Actions/Types";
import { getFilterContentApi, AddFilterContentApi, deleteFilterContentApi, UpdateFilterContentApi } from "../../Api/FilterContentApi";
import { BillingAddressPropTypes } from "../../PropTypes/BillingAddressPropTypes";
import { getUserDetailsService } from "../../Services/UserAction/LoginActionService";

const AddFilterContentService = (
  website_id: string,
  title: string, // Command title
  accessToken:string,
  setFilterContentListData: Function, // dispatch function to store redux data
  setShowFilterContentPopup: Function, // dispatch function to store redux data
  dispatch: Function, // dispatch function to store redux data
  t: Function, // i18next t function
  resetForm: Function, // resetForm t function,
) => {
  // Set Loading
  dispatch({
    type: LOADING,
    payload: true,
  });

  // api to perform action on bulk domains
  AddFilterContentApi(website_id, title, accessToken).then((response) => {
      // remove Loading
       if (response.data) {
            // service to get card list
            getFilterContentService(accessToken, website_id, setFilterContentListData, dispatch, t);

        }
      dispatch({
        type: LOADING,
        payload: false,
      });

      setShowFilterContentPopup(false)
      dispatch({
        type: SET_MESSAGE,
        payload: {
          toast_message: t(response.message),
          toast_type: "success",
        },
      });

      resetForm()
  });
};

const UpdateFilterContentService = (
  id:number,
  website_id: string,
  title: string, // Command title
  accessToken:string,
  setFilterContentListData: Function, // dispatch function to store redux data
  setShowFilterContentPopup: Function, // dispatch function to store redux data
  dispatch: Function, // dispatch function to store redux data
  t: Function, // i18next t function,
  resetForm: Function, // resetForm t function,
) => {
  // Set Loading
  dispatch({
    type: LOADING,
    payload: true,
  });

  // api to perform action on bulk domains
  UpdateFilterContentApi(id,website_id, title, accessToken).then((response) => {
    // remove Loading
    if (response.data) {
        
        // service to get card list
        getFilterContentService(accessToken, website_id, setFilterContentListData, dispatch, t);

    }
    dispatch({
    type: LOADING,
    payload: false,
    });

    setShowFilterContentPopup(false)
    dispatch({
    type: SET_MESSAGE,
    payload: {
        toast_message: t(response.message),
        toast_type: "success",
    },
    });

    resetForm()
  });
};


// service to get card list
const getFilterContentService = (
    accessToken: string, // access token
    website_id: string, // domain id
    setFilterContentListData: Function, // function to set Voice Command list
    dispatch: Function, // function to store redux data
    t: Function // i18next t function
) => {

    // API to get card list
    getFilterContentApi(accessToken, website_id).then(response => {
        // check response data is available
        if (response.data) {
            setFilterContentListData(response.data);
        }
    })
}

// service to delete card
const deleteFilterContentService = (
    accessToken: string, // access token
    website_id: string, // domain
    deleteFilterContentID: number, // voice command Id
    setFilterContentListData: Function, // function to voice command list
    setDeleteFilterContentPopup: Function, // function to close voice command popup
    dispatch: Function, // function to store redux data
    t: Function // i18next t function
) => {

    // API to delete card
    deleteFilterContentApi(accessToken, deleteFilterContentID).then(response => {
        // check if response data is available
        if (response) {
            //setCardListData(response.Data);

            // service to get card list
            getFilterContentService(accessToken, website_id, setFilterContentListData, dispatch, t);

            // hide delete card popup
            setDeleteFilterContentPopup(false)

            // dispatch card delete success message
            dispatch({
                type: SET_MESSAGE,
                payload: {
                    "toast_message": t('Land Mark Deleted Successfully!'),
                    "toast_type": "success"
                }
            })
        }
    })
}


export {
  AddFilterContentService,
  getFilterContentService,
  deleteFilterContentService,
  UpdateFilterContentService
};
